<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="title flex f14"></div>
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" >
      <van-icon @click='close()' name="close"  />
    </div>
  </div>
</template>

<script>
  import searchMixin from "@/mixins/search.js"
  export default {
    mixins:[searchMixin],
  }
</script>

<style lang="less" scoped>
.search{
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox{
    width: 9.2rem;
    height: 5.6666667rem;
    box-sizing: border-box;
    position: relative;
    .content{
      width: 96%;
      background: #FFE7E6;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;
      padding: .6rem;
      box-sizing: border-box;
      .title{
        width: 2.4rem;
        height:.4266667rem;
        background: url("@/assets/orangepolitics/seach.png") no-repeat;
        background-size: 100% 100%;
        margin: auto;
        color: #ffe696;
      }
      .input{
        margin: .8rem 0 .8rem;
        .van-search{
          background: #FCF4ED;
          border: 0.02rem solid #E58260;
          padding: 0;
        }
      }
      .searchBtn{
        height: .96rem;
        width: 100%;
        box-sizing: border-box;
        .van-button{
          width: 100%;
          height: 100%;
          color: #fff;
          background: -webkit-gradient(linear,left top,right top,from(#FB6034),to(#E71900));
          background: -webkit-linear-gradient(left,#FB6034 0%,#E71900 100%);
          background: -o-linear-gradient(left,#FB6034 0%,#E71900 100%);
          background: linear-gradient(90deg,#FB6034 0%,#E71900 100%);
          border: none;
        }
      }
    }
  }
  div.close{
    margin-top: .5333333rem;
    .van-icon-close{
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>